import React from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

// Matches FeedCard's shape so the feed doesn't jump on load.
function FeedCardSkeleton() {
    return (
        <Card variant="outlined" sx={{ borderRadius: 3, overflow: 'hidden' }}>
            <Skeleton variant="rectangular" sx={{ aspectRatio: '16 / 9', height: 'auto' }} />
            <Box sx={{ p: '14px 16px 16px' }}>
                <Skeleton width="45%" height={14} />
                <Skeleton width="80%" height={26} sx={{ mt: 0.5 }} />
                <Skeleton width="60%" height={18} sx={{ mt: 0.5 }} />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                    <Skeleton variant="circular" width={28} height={28} />
                    <Skeleton variant="rounded" width={96} height={32} />
                </Box>
            </Box>
        </Card>
    );
}

export default FeedCardSkeleton;
